import { Controller } from "@hotwired/stimulus"

// The name field on "Tilføj tilmelding" doubles as a member search. Typing
// asks Admin::MemberSuggestionsController for members with that name; picking
// one fills in name, phone and e-mail and remembers which member it was, so
// the signup is tied to them. Changing the name afterwards lets go of the
// member again, since it is then somebody else.
export default class extends Controller {
  static targets = ["name", "phone", "email", "memberId", "frame", "picked", "pickedName"]
  static values  = { url: String, minimumQuery: { type: Number, default: 2 } }

  disconnect() {
    clearTimeout(this.timer)
  }

  search() {
    if (this.memberIdTarget.value && this.nameTarget.value !== this.pickedName) this.unlink()

    clearTimeout(this.timer)
    const query = this.nameTarget.value.trim()

    if (query.length < this.minimumQueryValue) {
      this.clearSuggestions()
      return
    }

    // One request per pause in typing: the server decrypts its way through
    // the members to match a name.
    this.timer = setTimeout(() => {
      this.frameTarget.src = `${this.urlValue}?q=${encodeURIComponent(query)}`
    }, 300)
  }

  pick(event) {
    const { memberId, memberName, memberPhone, memberEmail } = event.currentTarget.dataset

    this.nameTarget.value     = memberName
    this.phoneTarget.value    = memberPhone || ""
    if (memberEmail) this.emailTarget.value = memberEmail
    this.memberIdTarget.value = memberId
    this.pickedName      = memberName

    this.pickedNameTarget.textContent = memberName
    this.pickedTarget.hidden = false
    this.clearSuggestions()
    this.nameTarget.focus()
  }

  unlink() {
    this.memberIdTarget.value = ""
    this.pickedName = null
    this.pickedTarget.hidden = true
  }

  clearSuggestions() {
    this.frameTarget.innerHTML = ""
    this.frameTarget.removeAttribute("src")
  }
}
